import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="printer"
export default class extends Controller {
  static targets = ['printable', 'button']

  connect() {
    this.buttonTarget.addEventListener('click', () => {
      this.printPageArea();
    });
  }

  printPageArea() {
    // Print the current page
    window.print();
  }
}
